"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalTooltipPositioner = void 0;
/**
 * This function is used to position the tooltip in the chart following the cursor's position.
 */
var externalTooltipPositioner = function (elements, position) {
    if (!elements.length) {
        return false;
    }
    var chart = this.chart;
    var offsetX = 0;
    var offsetY = 0;
    var tooltipEl = chart.canvas.parentNode.querySelector('.ui-chart-tooltip');
    var offsetSide = 10;
    if (tooltipEl) {
        var tooltipWidth = tooltipEl.offsetWidth;
        var tooltipHeight = tooltipEl.offsetHeight;
        offsetY = -tooltipHeight / 2;
        if (chart.width / 2 > position.x) {
            offsetX = tooltipWidth / 2 + offsetSide;
        }
        else {
            offsetX = -tooltipWidth / 2 - offsetSide;
        }
    }
    if (!position) {
        return { x: 0, y: 0 };
    }
    return {
        x: position.x + offsetX,
        y: position.y + offsetY,
    };
};
exports.externalTooltipPositioner = externalTooltipPositioner;
